import React from 'react';

import robustAirframeDrone from '../../../main/assets/images/mrm1-5/robust-airframe.webp';
import robustAirframeDroneMobile from '../../../main/assets/images/mrm1-5/robust-airframe-mobile.webp';

export const RobustAirframe = () => {
  return (
    <section className="mrm1-robust-section">
      <div className="mrm1-robust-text">
        <div className="mrm1-robust-text-content">
          <div>
            <h2 className="mrm1-robust-title">
              <span style={{ whiteSpace: 'nowrap' }}>ALL-ROUND</span>{' '}
            </h2>
            <h2 className="mrm1-robust-title">ABILITY</h2>
          </div>
          <p className="mrm1-robust-description">
            Whatever you need, the{' '}
            <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> delivers. It
            succeeds as both a cost-effective trainer for other models in the
            MRM fleet, a payload delivery system capable of carrying 1kg over
            7km, and a potent kinetic tool adept at breaching and direct action.
          </p>
        </div>
        <div className="mrm1-robust-text-content">
          <div>
            <h2 className="mrm1-robust-title">
              <span style={{ whiteSpace: 'nowrap' }}>EFFICIENT</span>{' '}
            </h2>
            <h2 className="mrm1-robust-title">TRAINING</h2>
          </div>
          <p className="mrm1-robust-description">
            Built on the proven F405 core, the{' '}
            <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> integrates
            natively with the Orqa{' '}
            <span style={{ whiteSpace: 'nowrap' }}>Tac.Ctrl</span> and Ground
            Station. This means operators training on the{' '}
            <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> build the
            muscle memory they need to pilot every other platform in the Orqa
            tactical ecosystem with ease.
          </p>
        </div>
      </div>
      <div className="mrm1-robust-product-wrapper">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={robustAirframeDroneMobile}
          />
          <img
            src={robustAirframeDrone}
            alt="Airframe Product with reflection"
            className="mrm1-robust-product"
          />
        </picture>
      </div>
    </section>
  );
};
